import { Validator } from '@vista-digital/validator';
import { defaultShowtimeSummaryAssets, showtimeSummaryAssetsValidator } from './assets';
import { defaultShowtimeSummaryCdnOptions, showtimeSummaryCdnOptionsValidator } from './cdn-options';
import { defaultShowtimeSummaryConfig, showtimeSummaryConfigValidator } from './config';
import { defaultShowtimeSummaryDisplayText, showtimeSummaryDisplayTextValidator } from './display-text';
export const defaultShowtimeSummaryProps = {
    config: defaultShowtimeSummaryConfig,
    displayText: defaultShowtimeSummaryDisplayText,
    assets: defaultShowtimeSummaryAssets,
    cdnOptions: defaultShowtimeSummaryCdnOptions
};
export const showtimeSummaryPropsValidator = Validator.object({
    config: showtimeSummaryConfigValidator,
    displayText: showtimeSummaryDisplayTextValidator,
    assets: showtimeSummaryAssetsValidator,
    cdnOptions: showtimeSummaryCdnOptionsValidator
});
